var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('person-cell');
import { breakpoints, theme } from '@shapeable/theme';
import { PersonImage } from './person-image';
import { useLang } from '../hooks/use-lang';
import { useLink } from '../hooks/use-link';
import { LinkedinFilledIconGlyph, TwitterFilledIconGlyph } from '@shapeable/icons';
import { Badge } from '../elements/badge';
import { useComponentPropsFor } from '../context/component-props-context';
export var PersonCellPhotoSizes = {
  smallLink: 48,
  link: 80,
  banner: 160
};
export var PersonCellPhotoSizesTablet = {
  smallLink: 48,
  link: 80,
  banner: 160
};
export var PersonCellPhotoSizesDesktop = {
  smallLink: 48,
  link: 80,
  banner: 180
};
export var PersonCellDefaultProps = {
  size: 'link',
  showOrganisation: true,
  showPosition: true,
  showImage: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    color: ", ";\n    align-items: center;\n    font-weight: 300;\n    line-height: 1.3em;\n    font-size: ", "; \n    text-decoration: none;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    color: ", ";\n    align-items: center;\n    font-weight: 300;\n    line-height: 1.3em;\n    font-size: ", "; \n    text-decoration: none;\n\n    ", "\n  "])), theme.COLOR('strong'), theme.FONT_SIZE(16), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: 1em;\n    "], ["\n      font-size: 1em;\n    "])));
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-direction: row;\n    ", "\n  "], ["\n    flex-direction: row;\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: ", "em;\n    "], ["\n      font-size: ", "em;\n    "])), 16 / 14);
  })
});
var ImageStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    border: 1px solid ", ";\n    border-radius: 50%;\n\n    ", "\n  "], ["\n    margin-bottom: ", ";\n    border: 1px solid ", ";\n    border-radius: 50%;\n\n    ", "\n  "])), theme.UNIT(2), theme.COLOR('line-mid'), function (_a) {
    var _size = _a._size;
    return _size && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), PersonCellPhotoSizes[_size], PersonCellPhotoSizes[_size]);
  }),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n    margin-right: ", ";\n    margin-bottom: 0;\n  "], ["\n    ", "\n    margin-right: ", ";\n    margin-bottom: 0;\n  "])), function (_a) {
    var _size = _a._size;
    return _size && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), PersonCellPhotoSizesTablet[_size], PersonCellPhotoSizesTablet[_size]);
  }, theme.UNIT(4)),
  desktop: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), PersonCellPhotoSizesDesktop[_size], PersonCellPhotoSizesDesktop[_size]);
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    \n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    \n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme.UNIT(2));
  }),
  tablet: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", "\n    align-items: flex-start;\n    text-align: left;\n  "], ["\n    ", "\n    align-items: flex-start;\n    text-align: left;\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme.UNIT(4));
  }),
  desktop: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme.UNIT(8));
  })
});
var NameStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    line-height: 1.1em;\n    font-size: 1.3em;\n    font-weight: 400;\n    margin: 0 !important;\n    padding-bottom: 0 !important;\n    color: ", ";\n    text-decoration: none;\n  "], ["\n    line-height: 1.1em;\n    font-size: 1.3em;\n    font-weight: 400;\n    margin: 0 !important;\n    padding-bottom: 0 !important;\n    color: ", ";\n    text-decoration: none;\n  "])), theme.COLOR('inherit')),
  tablet: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      font-size: 1.5em;\n    "], ["\n      font-size: 1.5em;\n    "])));
  })
});
var PositionStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    font-size: 0.9em;\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n    font-weight: 400;\n  "], ["\n    font-size: 0.9em;\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n    font-weight: 400;\n  "])), theme.UNIT(1), theme.COLOR('text')),
  tablet: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(2));
  })
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    font-size: 0.9em;\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n  "], ["\n    font-size: 0.9em;\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n  "])), theme.UNIT(1), theme.COLOR('text')),
  tablet: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(2));
  })
});
var FooterStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    gap: ", ";\n    padding-top: ", ";\n  "])), theme.UNIT(2), theme.UNIT(4))
});
var SocialsStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n  "], ["\n    display: flex;\n    gap: ", ";\n  "])), theme.UNIT(2))
});
var ActiveBadgeStyles = breakpoints({
  base: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    line-height: 1.25em;\n  "], ["\n    line-height: 1.25em;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(PersonImage)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Name: styled.h1.attrs(cls.attr('name'))(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Position: styled.span.attrs(cls.attr('position'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  Organisation: styled.span.attrs(cls.attr('organisation'))(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  Socials: styled.div.attrs(cls.attr('socials'))(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), SocialsStyles),
  ActiveBadge: styled(Badge)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ActiveBadgeStyles)
};
export var PersonCell = function (props) {
  var _a = useComponentPropsFor('PersonCell', PersonCellDefaultProps, props),
    className = _a.className,
    entity = _a.entity,
    size = _a.size,
    showPosition = _a.showPosition,
    showOrganisation = _a.showOrganisation,
    transform = _a.transform,
    showImage = _a.showImage;
  var organisation = entity.organisation,
    id = entity.id,
    name = entity.name,
    slug = entity.slug,
    position = entity.position,
    linkedin = entity.linkedin,
    twitter = entity.twitter,
    badge = entity.badge;
  var Link = useLink().Link;
  var t = useLang();
  var swallowEvent = function (event) {
    event.stopPropagation();
  };
  return React.createElement(My.Container, {
    _size: size,
    className: cls.name(className)
  }, React.createElement(My.Image, {
    transform: transform,
    showImage: showImage,
    size: 0,
    _size: size,
    entity: entity
  }), React.createElement(My.Body, {
    _size: size
  }, name && React.createElement(My.Name, {
    _size: size
  }, name), position && showPosition && React.createElement(My.Position, {
    _size: size
  }, position), organisation && showOrganisation && React.createElement(My.Organisation, {
    _size: size
  }, organisation.name), React.createElement(My.Footer, null, twitter && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Twitter'),
    href: twitter,
    target: "_blank"
  }, React.createElement(TwitterFilledIconGlyph, {
    size: 26
  })), linkedin && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Linkedin'),
    href: linkedin,
    target: "_blank"
  }, React.createElement(LinkedinFilledIconGlyph, {
    size: 26
  })), badge && React.createElement(My.ActiveBadge, null, t(badge)))));
};
// PersonCell.defaultProps = PersonCellDefaultProps;
PersonCell.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37;